/**
 * Moved to `shared/src/review/inventory-page-signals.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildPageSignalsForUrl,
  buildPageSignalsIndex
} from '@taptimize/shared/dist/review/inventory-page-signals';
export type {
  ActionPlanRowStatus,
  InternalLinkSignalRow,
  InventoryPageSignal,
  InventoryPageSignalKind,
  PageSignalSourceRow,
  UnclusteredSignalRow
} from '@taptimize/shared/dist/review/inventory-page-signals';
